
import { getProjectDelete, getProjectPage } from "@/api/api-basic";
import piAccountNumber from "./account-number.vue";
import piActivationCodeAdd from "./components/activeation-code-add.vue";
import i18n from "@/config/i18n";
import {
  Component,
  // Prop,
  // Model,
  // Provide,
  // Watch
  Vue
} from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {
    piAccountNumber,
    piActivationCodeAdd
  }
})
export default class AlarmSetting extends Vue {
  private piAccountNumber: objAny = {};
  private piActivationCodeAdd: objAny = {};
  private childTab = false;

  private loading = false;
  private modelList = [];
  private oprList: object[] = [];
  // private deviceTypeList = [];
  private devTypeList: object[] = [];
  private alarmLevelList = [];
  private eventTypeList = [];
  private stationList = [];
  private total = 0;
  private time: object[] = [];

  private formInline: objAny = {
    beginTime: "",
    endTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    projectName: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("cardClient.projectName"),
      key: "projectName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.createUserName"),
      key: "createUserName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.activatedAmount"),
      key: "activatedAmount",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("cardClient.projectCode"),
      key: "projectCode",
      resizable: true,
      minWidth: 130,
      slot: "projectCode"
    },
    {
      title: i18n.t("cardClient.modifyTime"),
      key: "modifyTime",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  private typePkId = "";
  public isShow() {
    this.childTab = false;
  }
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public operSuccess(list: object[]): void {
    this.oprList = list;
  }
  public queryRate(): void {
    this.getTableList();
  }
  public addNewAbout(): void {
    this.piActivationCodeAdd.open();
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  //眼睛展示
  public handleShowEye(row: objAny, index: number) {
    row.showProjectCode = !row.showProjectCode;
    this.$set(this.tableList, index, row);
  }
  // licenc管理
  public licenceManage(item: objAny): void {
    this.childTab = true;
    // this.typePkId = item.typePkId;
    // this.dictionaryChild.initData(item);
    this.piAccountNumber.open(item, "update");
  }
  // 删除
  async delItemRate(row: objAny): Promise<void> {
    const ret = await getProjectDelete({ projectPkId: row.projectPkId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async getTableList(): Promise<void> {
    // if (this.formInline.beginTime == "" || this.formInline.endTime == "") {
    //   this.$Message.error("时间不能为空 !");
    //   return;
    // }
    this.loading = true;
    const ret = await getProjectPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      if (ret.data) {
        this.total = ret.total;
        this.tableList = ret.data;
        ret.data.map((item: objAny) => {
          item.showProjectCode = false;
        });
      } else {
        this.total = 0;
        this.tableList = [];
      }
    }
    this.loading = false;
  }

  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.beginTime = this.$common.userDate(val[0]).split(" ")[0];
      this.formInline.endTime = this.$common.userDate(val[1]).split(" ")[0];
    } else {
      this.formInline.beginTime = "";
      this.formInline.endTime = "";
    }
  }
  public created(): void {
    const beginTime = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.formInline.beginTime = beginTime + "-01";
    this.formInline.endTime = endTime;
    // this.formInline.beginTime = "2020-11-01";
    // this.formInline.endTime = "2020-12-31";
    this.time = [this.formInline.beginTime, this.formInline.endTime];

    this.getTableList();
  }
  mounted() {
    this.$nextTick((): void => {
      this.piActivationCodeAdd = this.$refs["piActivationCodeAdd"];
      this.piAccountNumber = this.$refs["piAccountNumber"];
    });
    // this.privilege = this.$route.meta.privilegeVoObj;
  }
}
